/*
    Device List Empty View
*/

import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import Radio from 'backbone.radio';
import template from '@/../templates/device-list-empty.hbs';

    var globalCh = Radio.channel('global');

    var DeviceListEmptyView = Marionette.View.extend({
        template: Handlebars.compile(template),
        ui: {
            'assign': '.assign-button',
            'blinkup': '.blinkup-button',
        },
        events: {
            'click @ui.assign': 'show_assign_device_dialog',
            'click @ui.blinkup': 'show_blinkup_dialog',
        },
        show_assign_device_dialog: function (e) {
            e.preventDefault();
            var devicegroup = this.options.devicegroup;
            var options = {};

            switch (devicegroup && devicegroup.type) {
                case 'development_devicegroup':
                    options.omitted_types = ['pre_production_devicegroup', 'production_devicegroup', 'dut_devicegroup', 'pre_dut_devicegroup'];
                    break;
                case 'production_devicegroup':
                    options.omitted_types = ['pre_production_devicegroup', 'factoryfixture_devicegroup', 'development_devicegroup',
                                            'pre_factoryfixture_devicegroup', 'dut_devicegroup', 'pre_dut_devicegroup'];
                    break;
                case 'pre_production_devicegroup':
                    options.omitted_types = ['production_devicegroup', 'development_devicegroup', 'pre_factoryfixture_devicegroup',
                                             'factoryfixture_devicegroup', 'pre_dut_devicegroup', 'dut_devicegroup'];
                    break;
                case 'pre_factoryfixture_devicegroup':
                    options.omitted_types = ['pre_production_devicegroup', 'production_devicegroup', 'dut_devicegroup', 'pre_dut_devicegroup'];
                    break;
                case 'factoryfixture_devicegroup':
                    options.omitted_types = ['pre_production_devicegroup', 'production_devicegroup', 'dut_devicegroup', 'pre_dut_devicegroup'];
                    break;
                case 'pre_dut_devicegroup':
                    options.omitted_types = ['development_devicegroup', 'pre_production_devicegroup', 'pre_dut_devicegroup',
                                            'pre_factoryfixture_devicegroup', 'production_devicegroup', 'factoryfixture_devicegroup',
                                            'dut_devicegroup'];
                    break;
                case 'dut_devicegroup':
                    options.omitted_types = ['development_devicegroup', 'pre_production_devicegroup', 'pre_dut_devicegroup',
                                            'pre_factoryfixture_devicegroup', 'production_devicegroup', 'factoryfixture_devicegroup',
                                            'dut_devicegroup'];
                    break;
                default:
                    break;
            }

            if (devicegroup) {
                options.selected_product = devicegroup.rel.get('product');
                options.selected_devicegroup = devicegroup;
                options.selected_devicegroup_type = devicegroup.type;
            } else {
                options.omitted_types = ["pre_production_devicegroup", "production_devicegroup", "factoryfixture_devicegroup"]; 
            }
            globalCh.request('show_move_devices_dialog', options);
        },
        show_blinkup_dialog: function (e) {
            e.preventDefault();
            var primary = globalCh.request('primary_account');
            globalCh.request('changeActiveAccount', primary, () => {
                globalCh.request('set_selection', {
                    type: 'app',
                    id: 'blinkup',
                });
                globalCh.request('show_blinkup', primary);
            });
        },
        templateContext: function() {
            var devicegroup = this.getOption('devicegroup');
            var human_type;
            var include_blinkup = false;
            var allow_assign = true;

            if (devicegroup) {
                switch (devicegroup.type) {
                    case 'development_devicegroup':
                        human_type = 'Development Devices';
                        include_blinkup = true;
                        break;

                    case 'production_devicegroup':
                        human_type = 'Production Devices';
                        break;
                    
                    case 'pre_production_devicegroup':
                        human_type = 'Test Production Devices';
                        break;

                    case 'pre_factoryfixture_devicegroup':
                        human_type = 'Test Fixtures';
                        break;

                    case 'factoryfixture_devicegroup':
                        human_type = 'Fixtures';
                        break;

                    case 'pre_dut_devicegroup':
                        human_type = 'Test DUT Devices';
                        allow_assign = false;
                        break;

                    case 'dut_devicegroup':
                        human_type = 'DUT Devices';
                        allow_assign = false;
                        break;

                    default:
                        human_type = 'Development Devices';
                        break;
                }
            } else {
                human_type = 'Development Devices';
                include_blinkup = true;
            }

            return {
                type: human_type,
                include_blinkup: include_blinkup,
                allow_assign: allow_assign
            };
        },
    });

    export default DeviceListEmptyView;

